import { render } from "./crmHome.vue?vue&type=template&id=61d4abad&scoped=true"
import script from "./crmHome.vue?vue&type=script&lang=js"
export * from "./crmHome.vue?vue&type=script&lang=js"

import "./crmHome.vue?vue&type=style&index=0&id=61d4abad&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d4abad"]])

export default __exports__